<div class="footer-container">
    <div class="info-container">
        <div class="logos-container">
            <img src="assets/img/logo-europe.png" alt="Europe logo" height="50" width="76">
            <img src="assets/img/ministry-logo.png" alt="Ministry logo" height="50" width="200">
        </div>
        <div class="europe-div">
            <span style="display:block">{{'routeForm.europeFundRegionalDevelopment' | transloco}} (FEDER)</span>
            <span style="display:block">{{'routeForm.aWayToMakeEurope' | transloco}}</span>
        </div>
    </div>
    <div class="languageContainer">
        <img [alt]="'Current language flag ('+ selectedLanguage() + ')'"  [src]="imageSrc()">
        <mat-select disableOptionCentering panelClass="languageSelectorPanelClass" class="languageSelector" [value]="selectedLanguage()" (valueChange)="selectedLanguage.set($event)" name="language">
            <mat-option *ngFor="let language of availableLanguages" [value]="language">
              <img [alt]="language + 'flag'" [src]="getImgSource(language)">
              {{('languages.'+ language) | transloco}}
            </mat-option>
            <mat-select-trigger>
                <span>{{('languages.'+ selectedLanguage()) | transloco}}</span>
            </mat-select-trigger>
        </mat-select>
    </div>
</div>